import { Link } from "react-router-dom";
import { ArrowRight, BadgePercent } from "lucide-react";
import { trackEvent } from "../../lib/api";
import { ISDE_PATH } from "../../lib/isde";
import { ISDE_TEASERS } from "../../data/isdeContent";

export const IsdeTeaser = ({ path, text }) => {
  const body = text || ISDE_TEASERS[path];
  if (!body) return null;
  return (
    <section aria-label="ISDE-subsidie" className="section-tight" data-testid="isde-teaser">
      <div className="container-tight">
        <div className="flex flex-col gap-5 rounded-2xl border border-gold/25 bg-gold-soft/70 p-5 sm:flex-row sm:items-center sm:justify-between sm:p-6">
          <div className="flex gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-gold ring-1 ring-gold/20"><BadgePercent className="h-5 w-5" aria-hidden="true" /></span>
            <p className="max-w-2xl text-[15px] leading-relaxed text-ink">{body}</p>
          </div>
          <Link to={`${ISDE_PATH}#subsidiecheck`} onClick={() => trackEvent("cta_isde_click", { location: `teaser:${path}` })} data-testid="isde-teaser-cta"
            className="btn-secondary shrink-0 whitespace-nowrap">Bekijk uw subsidiemogelijkheden <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>
        </div>
      </div>
    </section>
  );
};
